module.exports = __webpack_public_path__ + "4892a89ee4056a8c0515b3a0ef670b4a.woff";